import React from 'react';

const WidgetLoader = () => {
  return <div className="widget_loader" />;
};

export default WidgetLoader;
